(function () {
  'use strict';

  var loadedApps = {};
  var marketingAllowed = false;
  var statisticsAllowed = false;

  var blockedMarketingScriptPatterns = [
    'extensions/019fefdf-95f0-7e1f-950f-cc1372213280/1click-popup-70',
    'cdn.growthhero.io/sites/pixel.js',
    'kochalpin.activehosted.com/js/site-tracking.php'
  ];

  var blockedStatisticsScriptPatterns = [
    'extensions/01a0140e-dc5d-7d7a-a81c-f7ad477f3582/easylocation-276'
  ];

  function matchesPattern(src, patterns) {
    return patterns.some(function (pattern) {
      return src.indexOf(pattern) !== -1;
    });
  }

  function isBlockedScript(node) {
    if (!node || node.tagName !== 'SCRIPT') {
      return false;
    }

    var src = node.src || node.getAttribute('src') || '';

    if (!marketingAllowed && matchesPattern(src, blockedMarketingScriptPatterns)) {
      return true;
    }

    if (!statisticsAllowed && matchesPattern(src, blockedStatisticsScriptPatterns)) {
      return true;
    }

    return false;
  }

  function blockAutomaticScripts() {
    var originalAppendChild = Node.prototype.appendChild;
    var originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.appendChild = function (node) {
      if (isBlockedScript(node)) {
        return node;
      }

      return originalAppendChild.call(this, node);
    };

    Node.prototype.insertBefore = function (node, referenceNode) {
      if (isBlockedScript(node)) {
        return node;
      }

      return originalInsertBefore.call(this, node, referenceNode);
    };
  }

  function loadScriptOnce(name, src, attributes) {
    if (loadedApps[name] || document.querySelector('[data-consent-controlled-app="' + name + '"]')) {
      return;
    }

    loadedApps[name] = true;

    var script = document.createElement('script');
    script.src = src;
    script.setAttribute('data-consent-controlled-app', name);

    Object.keys(attributes || {}).forEach(function (attribute) {
      script[attribute] = attributes[attribute];
    });

    script.addEventListener('error', function () {
      loadedApps[name] = false;

      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    }, { once: true });

    document.head.appendChild(script);
  }

  function loadOneClickPopup() {
    window.OneClickPopup = window.OneClickPopup || {};

    loadScriptOnce(
      'one-click-popup',
      'https://cdn.shopify.com/extensions/019fefdf-95f0-7e1f-950f-cc1372213280/1click-popup-70/assets/1click-popup-snippet.js',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadGrowthHero() {
    loadScriptOnce(
      'growth-hero',
      'https://cdn.growthhero.io/sites/pixel.js?shop=contourskins.myshopify.com',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadActiveCampaign() {
    loadScriptOnce(
      'active-campaign',
      'https://cdn.shopify.com/proxy/94c2a342c91faf4de9fe60356080077cffd8ae24cf43df48bd3fd6e0c52413cb/kochalpin.activehosted.com/js/site-tracking.php?shop=contourskins.myshopify.com&sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadEasyLocation() {
    loadScriptOnce(
      'easy-location',
      'https://cdn.shopify.com/extensions/01a0140e-dc5d-7d7a-a81c-f7ad477f3582/easylocation-276/assets/easylocation-storefront.min.js',
      { type: 'text/javascript' }
    );
  }

  function checkConsent() {
    // Source of truth is Consentmo's own SDK (window.Consentmo), not the raw event payload:
    // consentmoSignal_onLoad and consentmoSignal carry different, inconsistent detail shapes.
    if (!window.Consentmo) {
      return;
    }

    if (window.Consentmo.marketingAllowed()) {
      if (!marketingAllowed) {
        marketingAllowed = true;
        loadOneClickPopup();
        loadGrowthHero();
        loadActiveCampaign();
      }
    } else if (marketingAllowed) {
      window.location.reload();
      return;
    }

    if (window.Consentmo.analyticsAllowed()) {
      if (!statisticsAllowed) {
        statisticsAllowed = true;
        loadEasyLocation();
      }
    } else if (statisticsAllowed) {
      window.location.reload();
      return;
    }
  }

  document.addEventListener('consentmoSignal', checkConsent);

  document.addEventListener('consentmoSignal_onLoad', function (event) {
    var consentmoState = event.detail || { isActive: false };

    if (!consentmoState.isActive) {
      marketingAllowed = true;
      statisticsAllowed = true;
      loadOneClickPopup();
      loadGrowthHero();
      loadActiveCampaign();
      loadEasyLocation();
      return;
    }

    checkConsent();
  });

  blockAutomaticScripts();
})();
